// src/hooks/useTickets.js

import { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import { fetchTickets, updateTicketStatus } from "../services/ticketService";

export const useTickets = () => {
  const [tickets, setTickets] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Load tickets (only when called)
  const loadTickets = useCallback(async () => {
    try {
      setLoading(true);
      const data = await fetchTickets();
      setTickets(data);
      setError(null);
    } catch (err) {
      setError("Failed to load tickets");
      toast.error("Failed to load tickets");
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  // Initial load (no polling)
  useEffect(() => {
    loadTickets();
  }, [loadTickets]);

  // Update a ticket
  const updateTicket = useCallback(async (ticketId, remark, resolved = false) => {
    if (!remark?.trim()) {
      toast.error("Please add a remark before updating.");
      return false;
    }

    try {
      const updatedTickets = await updateTicketStatus(ticketId, remark, resolved);
      setTickets(updatedTickets);
      toast.success("Ticket updated successfully!");
      return true;
    } catch (err) {
      toast.error(
        err.message === "Remark is required"
          ? "Please add a remark."
          : "Failed to update ticket"
      );
      return false;
    }
  }, []);

  // Manual refresh
  const refresh = useCallback(() => {
    loadTickets();
  }, [loadTickets]);

  return {
    tickets,
    loading,
    error,
    updateTicket,
    refresh,
  };
};